import React from 'react';
import PropTypes from 'prop-types';

import styled from '@emotion/styled';
import {Trans} from 'gatsby-plugin-react-i18next';

import {breakpoints, colors, ContentContainer} from '../../styles/theme';
import {h2BaseStyle, Hero} from '../common/Typography';
import AnimatedBackground from '../common/AnimatedBackground';
import HeroImage from '../../images/channels/hero-image.svg';
import ChannelsFilters from './ChannelsFilters';


/*
 * Private Elements
 */
const HeroImageContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    display: flex;
    align-items: center;
    padding-right: 4%;

    svg {
        height: 100%;
    }
`;

const HeroContainer = styled.div`
    position: relative;
`;

const HeroContentContainer = styled(ContentContainer)`
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: ${colors.white};
`;

const HeroTitleContainer = styled.div`
    margin-top: 20%;
    margin-bottom: 50px;
    text-align: center;

    display: flex;
    align-items: center;
    justify-content: center;

    ${Hero} {
        padding-left: 10%;
        padding-right: 10%;
    }

    @media (min-width: ${breakpoints.sm}) {
        ${Hero} {
            padding-left: 20%;
            padding-right: 20%;
        }
    }

    @media (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg}) {
        ${Hero} {
            ${h2BaseStyle};
            font-size: 38px;
        }
    }
`;

const HeroFiltersContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (min-width: ${breakpoints.md}) {
        padding-left: 65px;
        padding-right: 65px;
    }
`;


/*
 * Public Elements
 */
const ChannelsHero = ({filters, setFilters, filtersSchema}) => (
    <HeroContainer>
        <AnimatedBackground>
            <HeroImageContainer>
                <HeroImage />
            </HeroImageContainer>

            <HeroContentContainer>
                <HeroTitleContainer>
                    <Hero><Trans>Assemble connections between providers and payment methods.</Trans></Hero>
                </HeroTitleContainer>

                <HeroFiltersContainer id="filters">
                    <ChannelsFilters filters={filters} setFilters={setFilters} filtersSchema={filtersSchema} />
                </HeroFiltersContainer>
            </HeroContentContainer>
        </AnimatedBackground>
    </HeroContainer>
);

ChannelsHero.propTypes = {
    filters: PropTypes.object.isRequired,
    setFilters: PropTypes.func.isRequired,
    filtersSchema: PropTypes.object.isRequired,
};


/*
 * Exports
 */
export default ChannelsHero;
